import {
	debug
} from "util";

export default {
	install(Vue, options) {
		Vue.mixin({
				methods: {
					WindowOpen(url, isAPI) {
						if(isAPI || !(url.indexOf('http') > -1)) {
							url = this.checkFileType(url,'isOFD') ? this.getFileFullName(url) + '.ofd' : url
							url = this.$store.state.BASE_API + url
						};
						window.open(url, '_blank');
					},
					warnStyle(value, name) {
						let status = false;
						if(value) {
							if(value.indexOf(name) > -1) {
								status = true
							}
						}
						return status
					},
					copyText(val) {
						this.$copyText(val).then(e => {
							this.showMsg("已复制", 'success');
						}, e => {
							this.showMsg("复制失败，请重新尝试", 'error');
						})
					},
					showMsg(message, type) {
						type = this.isNull(type) ? "error" : type;
						const _this = this;
						_this.$message({
							message: message,
							duration: 10000,
							type: type
						});
					},
					newShowFile(url) {
						let newUrl = ""
						if(!(url.indexOf('http') > -1)) {
							newUrl = this.$store.state.BASE_API + url
						};
						return newUrl
					},
					getAccountingClassify() {
						const _this = this;
						_this.axios.post(_this.BASE_API + 'PCVoucher/GetAccountingClassify')
							.then(function(response) {
								if(response.IsSuccess) {
									_this.$store.commit("localStorageAccountingOPT", response.ResultObject);
								}
							})
							.catch(function(error) {
								_this.showMsg(error, 'error');
							})
					},
					addWebLog(webLog) {
						const _this = this;
						_this.axios.post(_this.BASE_API + 'Voucher/AddWebLog', webLog)
							.then(function(response) {})
							.catch(function(error) {})
					},
					//刷新数据库缓存
					clearCache() {
						const _this = this;
						_this.axios.post(_this.BASE_API + "PC/PCHome/ClearCache")
							.then(function(response) {
								_this.showMsg(response.ResultMsg, "success");
							}).catch(function(error) {
								_this.showMsg(response.ResultMsg, "error");
							})

					},
					countTaxAmount(InvoiceAmount, TaxRate) {
						let num = 0;
						if(!this.isNull(InvoiceAmount) && !this.isNull(TaxRate)) {
							num = this.formatNum((InvoiceAmount / (1 + TaxRate)) * TaxRate)
						}
						return num
					},
					PaymentClick(row, column) {
						this.$store.commit("seesionReBack", this.$route.fullPath);
						if(this.$route.path === "/Payment/List" || this.$route.path === "/OnlineBank/Payment") {
							this.$store.commit("seesionPaySearchItem", this.search);
						};
						let queryT = {
							id: row.Id
						};
						if(row.IsAutomatic == true) {
							queryT = {
								id: row.Id,
								isAutomatic: 1
							}
						}
						if(column.type !== 'selection' && column.label !== "操作") {
							this.$router.push({
								path: '/Payment/Form',
								query: queryT
							});
						}
					},
					// 获取费用归属部门
					getAllDepartmentList() {
						const _this = this;
						_this.axios.post(_this.BASE_API + 'Voucher/GetPayDepartmentList')
							.then(function(response) {
								if(response.IsSuccess) {
									_this.DepartmentOPT = response.ResultObject.DataObject;
									_this.DepartmentTypeOPT = response.ResultObject.DeptTypt;
								} else {
									_this.showMsg(response.ResultMsg, "error")
								}
							}).catch(function(error) {
								_this.showMsg(error, "error");
							})
					},
					// 留言部分
					getMessageBoardList(idkey) {
						const _this = this;
						_this.axios.post(this.$store.state.BASE_API + 'MessageNotice/GetMessageBoardList', {
								FormId: idkey
							})
							.then(function(response) {
								if(response.IsSuccess) {
									response.ResultObject.forEach((item) => {
										item.showInput = false;
									});
									_this.MessageBoardList = response.ResultObject
								} else {
									_this.showMsg(response.ResultMsg, 'error');
								}
							}).catch(function(error) {
								_this.showMsg(error, 'error');
							})
					},
					getMailUser(val) {
						const _this = this;
						if(_this.isNull(_this.saveUserEmail)) {
							if(!_this.isNull(val.Name) && !_this.isNull(val.Email)) {
								_this.saveUserEmail.push({
									label: val.Email,
									value: val.Name
								})
							};
						}
					},
					getPersonList() {
						const _this = this;
						if(!_this.isNull(_this.FormData.form) || !_this.isNull(_this.FormData.Form)) {
							if(_this.isNull(sessionStorage.getItem("PersonListOPT"))) {
								_this.axios.post(_this.$store.state.BASE_API + 'MessageNotice/GetPersonList', {
										key: _this.searchKey
									})
									.then(function(response) {
										if(response.IsSuccess) {
											_this.$store.commit("sessionPersonListOPT", response.ResultObject);
											_this.PersonList = response.ResultObject;
										} else {
											_this.showMsg(response.ResultMsg, "error");
										}
									}).catch(function(error) {
										_this.showMsg(error, "error");
									})
							} else {
								_this.$store.commit("sessionPersonListOPT", JSON.parse(sessionStorage.getItem(
									"PersonListOPT")));
								_this.PersonList = JSON.parse(sessionStorage.getItem("PersonListOPT"))
							}
						}
					},
					delTag(i) {
						this.saveUserEmail.splice(i, 1)
					},
					checkShowInput(row, rowIndex) {
						let temArr = this.deepClone(this.MessageBoardList);
						temArr.forEach((item, idx) => {
							if(idx === rowIndex) {
								item.showInput = !item.showInput;
							} else {
								item.showInput = false;
							}
						});
						this.MessageBoardList = temArr;
					},
					unPC() {
						var userAgentInfo = navigator.userAgent;
						var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
						var flag = false;
						for(var v = 0; v < Agents.length; v++) {
							if(userAgentInfo.indexOf(Agents[v]) > 0) {
								flag = true;
								break;
							}
						}
						if(document.documentElement.clientWidth < 800) {
							flag = true
						}
						return flag;
					},
					getQueryVariable(variable) {
						let query = window.location.search.substring(1);
						let vars = query.split("&");
						for(var i = 0; i < vars.length; i++) {
							var pair = vars[i].split("=");
							if(pair[0] == variable) {
								return pair[1];
							}
						}
						return(false);
					},
					getCount() {
						const _this = this;
						_this.axios.post(this.$store.state.BASE_API + 'Voucher/GetCount')
							.then(function(response) {
								if(response.IsSuccess) {
									var count = _this.deepClone(response.ResultObject);
									//个人报销
									count.PayCount = parseInt(count.PayApply) + parseInt(count
										.PayReplenishBill) + parseInt(count.PayApproval) + parseInt(count
										.PayActing);
									//票据管理
									count.InvoicCount = parseInt(count.InvoicApply) + parseInt(count
										.InvoicApproval) + parseInt(count.InvoiceAct);
									//油站扣款
									count.Owe = parseInt(count.OwiApply) + parseInt(count.OwiApproval) +
										parseInt(count.OwiActing);
									//事项审核
									count.SysCount = parseInt(count.SubjectCount) + parseInt(count.MetterCount);
									_this.$store.commit("sessionCount", count);
								} else {
									_this.showMsg(response.ResultMsg, 'error');
								}
							}).catch(function(error) {
								_this.showMsg(error, 'error');
							})
					},
					messageeditorReply(ReplyId) {
						const _this = this;
						let parmas = _this.addMessage;
						if(ReplyId) {
							parmas = _this.replyMessage;
							parmas.ReplyId = ReplyId;
						}
						parmas.FormId = _this.$route.query.id;
						if(_this.isNull(parmas.Remark)) {
							_this.showMsg("留言信息不能为空！", 'error');
							return;
						};
						if(parmas.IsSendEmail && _this.isNull(_this.saveUserEmail)) {
							_this.showMsg("请选择邮件提醒人！", 'error');
							return;
						};
						let saveEmail = [];
						if(!_this.isNull(_this.saveUserEmail)) {
							_this.saveUserEmail.forEach(function(items) {
								saveEmail.push(items.label)
							});
							if(parmas.IsSendEmail) {
								parmas.UserEmail = saveEmail.toString()
							};
						}
						_this.axios.post(this.$store.state.BASE_API + 'MessageNotice/MessageeditorReply', parmas)
							.then(function(response) {
								if(response.IsSuccess) {
									_this.showMsg("发送成功!", 'success');
									_this.getMessageBoardList(_this.$route.query.id);
									_this.addMessage = {
										FormId: "",
										Remark: "",
										MessageType: 1, //1=留言;2=回复
										ReplyId: "",
										IsSendEmail: false,
										UserEmail: "",
									};
									_this.replyMessage = {
										FormId: "",
										Remark: "",
										MessageType: 2, //1=留言;2=回复
										ReplyId: "",
										IsSendEmail: false,
										UserEmail: "",
									};
									_this.saveUserEmail = [];
								} else {
									_this.showMsg(response.ResultMsg, 'error');
								}
							}).catch(function(error) {
								_this.showMsg(error, 'error');
							})
					},
					openFile(name, index) {
						$("#" + name).click();
						if(index != null) {
							this.FileNum = index
						}
					},
					downFileStream(res, fileName, suffix = "xlsx") {
						const blob = new Blob([res]);
						const setName = fileName;
						const elink = document.createElement('a');
						elink.download = setName + '-' + this.filterDate(new Date(), 'yyMMdd') + '.' + suffix;
						elink.style.display = 'none';
						elink.href = URL.createObjectURL(blob);
						document.body.appendChild(elink);
						elink.click();
						URL.revokeObjectURL(elink.href); // 释放URL 对象
						document.body.removeChild(elink);
					},
					getTicketType(val) {
						const _this = this;
						//						if(_this.isNull(localStorage.getItem("TicketFPConfigura"))) {
						_this.axios.post(_this.$store.state.BASE_API + 'Voucher/GetTicketType', {
								System: 2
							})
							.then(function(response) {
								if(response.IsSuccess) {
									_this.$store.commit("localStorageTicket", response.ResultObject);
								} else {
									_this.showMsg(response.ResultMsg, 'error');
								}
							}).catch(function(error) {
								_this.showMsg(error, 'error');
							})
						//						} else {
						//							_this.$store.commit("localStorageTicket", JSON.parse(localStorage.getItem("TicketFPConfigura")));
						//						}
					},
					//深度克隆
					deepClone(obj) {
						if(obj) {
							return JSON.parse(JSON.stringify(obj));
						}
					},
					downFiles(files, FileName) {
						this.WindowOpen(files.FilePath, true);
					},
					fileTerName(name) {
						var newName = "";
						if(!this.isNull(name)) {
							if(name.indexOf(':') > -1) {
								newName = name.substring(name.indexOf(':') + 1)
							} else if(name.indexOf('：') > -1) {
								newName = name.substring(name.indexOf('：') + 1)
							} else {
								newName = name
							};
						}

						return newName;
					},
					findTicketType(InvoiceType) {
						let type = 0;
						if(InvoiceType) {
							this.TicketConfigura.forEach(function(el) {
								if(el.FileType == InvoiceType) {
									type = el.TicketType
								}
							})
						}
						return type
					},
					canSeeAllList() {
						return this.userRole.IsAdmin || this.userRole.IsAccounting || this.userRole
							.IsAccountingManager || this.userRole.IsPI || this.userRole.IsFundSupervisor || this
							.userRole.IsCashier
					},
					isAutomatic(form) {
						let status = "";
						if(this.$route.meta.isActive == "个人报销") {
							status = "报销"
							if(!this.isNull(this.$route.query.isAutomatic) || this.$route.name ==
								"/OnlineBank/Automatic") {
								status = this.$route.query.isAutomatic == 1 || this.$route.name ==
									"/OnlineBank/Automatic" ? "扣款" : status;
							}
						}
						if(!this.isNull(form)) {
							status = form.IsAutomatic ? "扣款" : status;
						}
						if(this.$route.meta.isActive == "油站扣款") {
							status = "扣款"
						}
						return status
					},
					isOperationAuth() {
						return this.$store.state.userInfo.UserName == '睎慧'
					}
				}
			}),
			Vue.prototype.newAccountingClassifyOPT = function(accountingClassifyOPT) {
				const _this = this;
				let newObj = [];
				if(!this.isNull(accountingClassifyOPT)) {
					let oldObj = this.deepClone(accountingClassifyOPT);
					let formType = this.isAutomatic() == '扣款' || this.FormData.form.IsAutomatic == true ? 1 : 0;
					if(!this.isNull(oldObj)) {
						oldObj.forEach(function(el) {
							el.Automatic = el.Automatic == true ? true : false;
							if(formType == 1 && el.Automatic == true) {
								newObj.push(el)
							}
							if(formType == 0 && el.Automatic != true) {
								newObj.push(el)
							}
						})
					}
				}
				return newObj
			},
			Vue.prototype.LTrim = function(str) {
				str = str.replace(/^(\s|\u00A0)+/, '');
				for(var i = str.length - 1; i >= 0; i--) {
					if(/\S/.test(str.charAt(i))) {
						str = str.substring(0, i + 1);
						break;
					}
				}
				return str;
			},
			Vue.prototype.changeMoney = function(val) {
				//格式化 输入金额的格式
				let value = val.toString();
				let result = "";
				if(value.lastIndexOf('.') == -1) {
					result = (value + ".").replace(/(?=(\d{3})+[, .])/g, ',').replace(".", "");
				}
				if(value.lastIndexOf('.') != value.indexOf('.')) {
					result = (value.substring(0, value.length - 1)).replace(/(?=(\d{3})+[, .])/g, ',');
				}
				if(value.lastIndexOf('.') == value.indexOf('.') && value.lastIndexOf('.') != -1) {
					result = value.substring(0, value.indexOf('.') + 3).replace(/(?=(\d{3})+[, .])/g, ',');
				}
				if(result.indexOf(',') == 0) {
					result = result.substring(1);
				}
				return result;
			},
			Vue.prototype.formatDate = function(date, fmt) {
				if(/(y+)/.test(fmt)) {
					fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
				}
				let o = {
					'M+': date.getMonth() + 1,
					'd+': date.getDate(),
					'h+': date.getHours(),
					'm+': date.getMinutes(),
					's+': date.getSeconds()
				}
				for(let k in o) {
					let str = o[k] + '';
					if(new RegExp(`(${k})`).test(fmt)) {
						fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
					}
				}
				return fmt;
			}, Vue.prototype.StringToInvoiceDate = function(dateString) {
				const year = dateString.substring(0, 4);
				const month = dateString.substring(4, 6);
				const day = dateString.substring(6, 8);
				return new Date(`${year}-${month}-${day}`);
			},
			Vue.prototype.DaysBetween = function(dateStar, dateEnd) {
				var startDate = Date.parse(dateStar);
				var endDate = Date.parse(dateEnd);
				var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
				return Math.abs(days);
			},
			//附件图标
			Vue.prototype.getFileIcon = function(fileUrl) {
				let Icon = "static/img/file-icon/file.png";
				let fileName = ""
				if(!this.isNull(fileUrl)) {
					if(this.checkFileType(fileUrl, 'isPdf')) {
						Icon = "static/img/file-icon/pdf.jpg"
					};
					if(this.checkFileType(fileUrl, 'isOFD')) {
						Icon = "static/img/file-icon/OFD.jpg"
					};
					if(this.checkFileType(fileUrl, 'isWord')) {
						Icon = "static/img/file-icon/word.jpg"
					};
					if(this.checkFileType(fileUrl, 'isExcel')) {
						Icon = "static/img/file-icon/excel.jpg"
					};
					if(this.checkFileType(fileUrl, 'isXML')) {
						Icon = "static/img/file-icon/xml.jpeg"
					};
					if(this.checkFileType(fileUrl, 'isZip')) {
						Icon = "static/img/file-icon/zip.jpg"
					};
					if(this.getFileType(fileUrl) == "msg") {
						Icon = "static/img/file-icon/mail.jpg"
					};
					if(this.checkFileType(fileUrl, 'isJpg')) {
						Icon = this.$store.state.BASE_API + fileUrl;
					};
				}
				return Icon
			},
			Vue.prototype.fileTicketName = function(type) {
				let name = ""
				if(type) {
					this.$store.state.TicketConfigura.forEach(function(items) {
						if(items.FileType == type) {
							name = items.Name
						}
						if(type == 9) {
							name = "支持文件"
						}
						if(type == 1) {
							name = "商品采购"
						}
					})
				}
				return name
			},
			Vue.prototype.formatNum = function(num) {
				if(!num) {
					return 0;
				} else {
					var m = Math.pow(10, 2);
					return Math.round(num * m, 10) / m;
				}
			},
			Vue.prototype.getFileName = function(value) {
				return value.substring(value.lastIndexOf("."));
			},
			Vue.prototype.getFileFullName = function(value) {
				return value.substring(0, value.lastIndexOf("."));
			},
			Vue.prototype.getFileType = function(fileUrl) {
				if(fileUrl) {
					return fileUrl.split('.').pop().toLowerCase();
				} else {
					return ''
				}
			},
			//根据文件名和类型，进行匹配
			Vue.prototype.checkFileType = function(fileUrl, typeName) {
				let res = this.$store.state.OfficeFileType[typeName];
				var chekFiles = false;
				if(this.getFileType(fileUrl).match(res)) {
					chekFiles = true;
				}
				return chekFiles;
			},
			Vue.prototype.canWatchInvoice = function(row) {
				let result = false;
				if(this.canWatch(row.FilePath)) {
					result = true
				}
				if(this.getFileType(row.FilePath) === 'xml' && !this.isNull(row.VerifyInfo) && !this.isNull(row.VerifyInfo.PdfUrlLocal)) {
					result = true
				}
				return result
			},
			//可以在线浏览的格式判断
			Vue.prototype.canWatch = function(value) {
				let result = false;
				/*进行校验*/
				if(value) {
					if(this.checkFileType(value, 'isJpg') || this.checkFileType(value, 'isWord') || this.checkFileType(value, 'isExcel')  || this.checkFileType(value, 'isPdf')){
						result = true
					}
				}
				return result;
			},
			Vue.prototype.isNull = function(obj) {
				let result = false;
				if(obj == undefined || obj == [] || obj == '[]' || obj == null || obj == "" || JSON.stringify(obj) ==
					"{}" || obj.length == 0 || obj == "00000000-0000-0000-0000-000000000000") {
					result = true
				}
				return result;
			},
			Vue.prototype.back = function() {
				if(!this.isNull(this.$store.state.seesionReBack)) {
					this.$router.push({
						path: this.$store.state.seesionReBack
					});
					return
				}
				if(history.length == 1) {
					if(this.unPC()) {
						this.$router.push({
							path: '/m/Home'
						});
					} else {
						this.$router.push({
							path: "/Home"
						});
					}
				} else {
					this.$router.back();
				}
			},
			Vue.prototype.filterDate = function(date, fmt) {
				if(/(y+)/.test(fmt)) {
					fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
				}
				let o = {
					'M+': date.getMonth() + 1,
					'd+': date.getDate(),
					'h+': date.getHours(),
					'm+': date.getMinutes(),
					's+': date.getSeconds()
				}
				for(let k in o) {
					let str = o[k] + '';
					if(new RegExp(`(${k})`).test(fmt)) {
						fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str));
					}
				}
				return fmt;
			},
			Vue.prototype.padLeftZero = function(str) {
				return('00' + str).substr(str.length);
			}, // 防抖
			/* 
			  fn：函数
			  delay：间隔时间
			  beforeStartCallback：调用前需用到的回调
			*/
			Vue.prototype.debounce = function(fn, delay, beforeStartCallback) {
				var timer = null;
				return function() {
					var context = this;
					var args = arguments;
					beforeStartCallback && beforeStartCallback.apply(context, args)

					clearTimeout(timer);
					timer = setTimeout(function() {
						fn.apply(context, args);
					}, delay);
				};
			}, Vue.prototype.findTicketOPT = function(InvoiceType) {
				let type = {};
				if(InvoiceType) {
					this.$store.state.TicketConfigura.forEach(function(el) {
						if(el.FileType == InvoiceType) {
							type = el
						}
					})
				}
				return type
			}, Vue.prototype.NeedTaxType = function(InvoiceType) {
				let type = false;
				const _this = this;
				if(InvoiceType) {
					_this.$store.state.TicketConfigura.forEach(function(el) {
						if(el.FileType == InvoiceType) {
							type = el.NeedTax || !_this.isNull(el.TaxRate) && el.TaxRate > 0;
						}
					})
				}
				return type
			}, Vue.prototype.changeInvoiceType = function(ocrName, ticketNum) {
				let type = {};
				let invoiceName = this.findTicketOPT(ticketNum).Name;
				let ticketConfigura = this.$store.state.TicketConfigura;
				if(ocrName) {
					let Ele = (ocrName.includes("电子") || ocrName.includes("数电")) && !ocrName.includes("纸质"); ///电子
					let Invoice = ocrName.includes("普票") || ocrName.includes("普通"); //普通发票
					let Special = ocrName.includes("专票") || ocrName.includes("专用发票"); ///专用发票
					for(let i = 0; i < ticketConfigura.length; i++) {
						if(Ele && ticketConfigura[i].Name.indexOf("电子发票") > -1) {
							if(Invoice && ticketConfigura[i].Name.indexOf("普通发票") > 0 && invoiceName.indexOf('专用发票') >
								0) {
								type = ticketConfigura[i].FileType;
							}
							if(Special && ticketConfigura[i].Name.indexOf("专用发票") > 0 && invoiceName.indexOf('普通发票') >
								0) {
								type = ticketConfigura[i].FileType;
							}
						}
						if(!Ele && ticketConfigura[i].Name.indexOf("电子发票") == -1) {
							if(Invoice && ticketConfigura[i].Name.indexOf("普通发票") > 0 && invoiceName.indexOf('专用发票') >
								0) {
								type = ticketConfigura[i].FileType;
							}
							if(Special && ticketConfigura[i].Name.indexOf("专用发票") > 0 && invoiceName.indexOf('普通发票') >
								0) {
								type = ticketConfigura[i].FileType;
							}
						}
					}
				}
				return type
			},
			Vue.prototype.checkInvoiceItems = function(row, isType) {
				let msg = "识别失败";
				let type = "el-icon-question f-red";
				if(!this.isNull(row.VerifyInfo) && !this.isNull(row.VerifyId)) {
					if(this.isNull(row.VerifyInfo.InvoiceStatus)) {
						msg = "查验失败！";
						type = "el-icon-warning f-red"
					} else {
						msg = row.VerifyInfo.InvoiceStatus == "01" ? "查验正常" : row.VerifyInfo.InvoiceStatus == "02" ?
							"已作废" : row.VerifyInfo.InvoiceStatus == "03" ? "已全额红冲" : "已部分红冲";
						type = row.VerifyInfo.InvoiceStatus == "01" ? "el-icon-success f-green" :
							"el-icon-warning f-red";
					}
				} else
				if(!this.isNull(row.OCRInvoiceInfo)) {
					let ocrName = row.OCRInvoiceInfo.InvoiceTypeOrg;
					let ticketName = this.findTicketOPT(row.InvoiceType).Name;
					if(!this.isNull(ocrName) && ((ocrName.match("普票") || ocrName.match("普通")) && (ticketName.match(
							"专用") || ticketName.match("专票")) || (ocrName.match("专票") || ocrName.match("专用发票")) && (
							ticketName.match("普票") || ticketName.match("普通发票")))) {
						msg = "识别为：" + ocrName;
						type = "el-icon-warning f-red";
					} else {
						msg = this.isNull(row.OCRInvoiceInfo.InvoiceNumber) ? "识别失败" : "识别成功";
						type = this.isNull(row.OCRInvoiceInfo.InvoiceNumber) ? "el-icon-question f-red" :
							"el-icon-info f-primary";
					}
				}
				if(row.isFailNumber || row.isFailTax) {
					msg = (row.isFailNumber ? '收款方' : '税号') + "不一致！";
					type = "el-icon-question f-orange";
				}
				if(isType) {
					return type;
				} else {
					return msg
				}
			}
	}
}


// WEBPACK FOOTER //
// ./src/util/common.js